(() => {
  if (customElements.get('msport-flash-sale')) return;
  class MsportFlashSale extends HTMLElement {
    connectedCallback() {
      this.stop();
      const raw = this.dataset.end || '';
      // Require an explicit timezone, never interpret the visitor's local timezone.
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(Z|[+-]\d{2}:\d{2})$/.exec(raw);
      this.deadline = NaN;
      if (match) {
        const [, y, m, d, h, min, sec, zone] = match;
        const days = new Date(Date.UTC(Number(y), Number(m), 0)).getUTCDate();
        const zoneOK = zone === 'Z' || (Number(zone.slice(1,3)) <= 14 && Number(zone.slice(4)) < 60 && (Number(zone.slice(1,3)) < 14 || Number(zone.slice(4)) === 0));
        if (+m >= 1 && +m <= 12 && +d >= 1 && +d <= days && +h < 24 && +min < 60 && +sec < 60 && zoneOK) this.deadline = Date.parse(raw);
      }
      const ready = this.dataset.enabled === 'true' && this.dataset.hasProducts === 'true' && Number.isFinite(this.deadline);
      this.querySelector('[data-editor-note]').hidden = ready;
      this.querySelector('[data-timer]').hidden = true;
      this.querySelector('[data-products]').hidden = true;
      this.querySelector('[data-ended]').hidden = true;
      this.hidden = !ready && this.dataset.editor !== 'true';
      if (!ready) return;
      this.tick();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
    }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const ended = remaining === 0;
      this.querySelector('[data-timer]').hidden = ended;
      this.querySelector('[data-products]').hidden = ended;
      this.querySelector('[data-ended]').hidden = !ended;
      const values = { days: Math.floor(remaining/86400), hours: Math.floor(remaining/3600)%24, minutes: Math.floor(remaining/60)%60, seconds: remaining%60 };
      for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2,'0');
      if (ended) this.stop();
    }
    stop() { if (this.interval) clearInterval(this.interval); this.interval = null; }
    disconnectedCallback() { this.stop(); }
  }
  customElements.define('msport-flash-sale', MsportFlashSale);
})();
